/* Ping & Press wall: scroll reveals, switch traffic, foil sheen, and the unplug gag. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Things that happen when they scroll into view: heading tapes print,
       the switch boots, the SLA gets stamped. */
    var reveal = document.querySelectorAll('.pp-print, .pp-switch, .pp-sla');
    if (reduce || !('IntersectionObserver' in window)) {
      reveal.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -18% 0px', threshold: 0.2 });
      reveal.forEach(function (el) { io.observe(el); });
    }

    /* Switch: each port gets its own traffic pattern. */
    document.querySelectorAll('.pp-switch').forEach(function (sw) {
      sw.querySelectorAll('.pp-port').forEach(function (port, i) {
        port.style.setProperty('--i', i);
        var act = port.querySelector('.pp-led--amber');
        if (act) {
          act.style.setProperty('--act', (1.2 + Math.random() * 1.6).toFixed(2) + 's');
          act.style.setProperty('--act-d', (0.9 + i * 0.13 + Math.random() * 0.8).toFixed(2) + 's');
        }
      });
    });

    /* Asset tag foil follows the pointer. */
    var tags = document.querySelectorAll('.pp-asset');
    if (tags.length && !reduce && window.matchMedia('(hover: hover)').matches) {
      var raf = 0, mx = 0.3;
      window.addEventListener('pointermove', function (ev) {
        mx = ev.clientX / window.innerWidth;
        if (!raf) {
          raf = requestAnimationFrame(function () {
            raf = 0;
            tags.forEach(function (t) { t.style.setProperty('--mx', mx.toFixed(3)); });
          });
        }
      }, { passive: true });
    }

    /* DO NOT UNPLUG. */
    var lines = ['I said do not unplug', 'Plugged back in. Again.', 'Do not unplug'];
    document.querySelectorAll('.pp-unplug').forEach(function (btn) {
      var n = 0;
      btn.addEventListener('click', function () {
        var label = btn.querySelector('[data-pp-label]') || btn;
        var next = lines[Math.min(n, lines.length - 1)];
        n = (n + 1) % lines.length;
        if (reduce) {
          label.textContent = next;
          return;
        }
        var scr = document.createElement('div');
        scr.className = 'pp-nosignal';
        scr.setAttribute('role', 'status');
        scr.innerHTML = '<div class="pp-nosignal__osd"><b>No signal</b><span>Check the cable connection</span></div>';
        document.body.appendChild(scr);
        requestAnimationFrame(function () { scr.classList.add('is-on'); });
        var t1 = setTimeout(function () { scr.classList.add('is-osd'); }, 450);
        var done = function () {
          clearTimeout(t1);
          clearTimeout(t2);
          label.textContent = next;
          scr.remove();
          btn.focus({ preventScroll: true });
        };
        var t2 = setTimeout(done, 2600);
        scr.addEventListener('click', done, { once: true });
      });
    });
  });
})();
